import { css } from 'styled-components'
import { colors } from 'themes/index'

const scrollbarsCSS = css`
  ::-webkit-scrollbar {
    background-color: ${colors.white100};
    width: 16px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${colors.white100};
  }
  ::-webkit-scrollbar-track:hover {
    background-color: ${colors.white};
  }
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 5px solid ${colors.white100};
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #a0a0a5;
    border: 4px solid ${colors.white};
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
`

export default scrollbarsCSS
